import Ease from '@CS/utils/Easing';
import { Screen } from '@CS/app/App.styles';
import styled, { css, keyframes } from 'styled-components';

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }

  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
`;

type LoaderAttributes = {
  $overlay?: boolean;
  opacity?: number;
};

export const LoaderStyle = styled.aside<LoaderAttributes>(
  ({ $overlay, opacity = 0.0 }) => css`
    transform: translateX(-50%);
    max-width: ${Screen.MAX};

    position: fixed;
    display: block;

    height: 100%;
    width: 100%;

    z-index: 1;
    left: 50%;
    top: 0;

    ${$overlay &&
    css`
      background-color: rgb(0 0 0 / ${opacity});
    `}
  `
);

type ImageAttributes = {
  width: number;
};

export const ImageStyle = styled.div<ImageAttributes>(
  ({ width }) => css`
    position: absolute;
    width: ${width}px;
    display: flex;
    flex-direction: column;
    align-items: center;

    height: auto;
    margin: auto;

    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
  `
);

export const LoadingText = styled.span`
  margin-top: 12px;
  color: white;
  font-family: inherit;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
  text-align: center;
`;

type SpinnerAttributes = ImageAttributes & {
  color: string;
  speed: number;
};

export const SpinnerStyle = styled.div<SpinnerAttributes>(
  ({ color, speed, width }) => css`
    position: absolute;

    height: ${width}px;
    width: ${width}px;
    margin: auto;

    bottom: 0;
    right: 0;
    left: 0;
    top: 0;

    &::before {
      padding-top: 100%;
      display: block;
      content: '';
    }

    svg {
      animation: ${rotate} ${speed / 1.55}s linear infinite;
      transform-origin: 50%;

      position: absolute;
      margin: auto;

      height: 100%;
      width: 100%;

      bottom: 0;
      right: 0;
      left: 0;
      top: 0;
    }

    circle {
      animation: ${dash} ${speed}s ${Ease.InOut.Sine} infinite;

      stroke-dasharray: 1, 200;
      stroke-linecap: round;
      stroke-dashoffset: 0;
      stroke-width: 5px;
      stroke: ${color};
    }
  `
);
